import {HTMLAttributes} from 'react';
import {createPortal} from 'react-dom';
import {IS_CLIENT_SIDE} from '../../../common/shared/utils/constants';
import {twMerge} from '../../../common/twMerge';
import {PC_SEARCH_MODAL_ROOT_ID} from '../../../domain/search/constant';

interface PcSearchesModalProps extends HTMLAttributes<HTMLDivElement> {
  open: boolean;
}

export function PcSearchesModal({
  open,
  className,
  children,
  ...props
}: PcSearchesModalProps) {
  if (!IS_CLIENT_SIDE || !open) {
    return null;
  }

  const pcSearchModalRootElement = document.getElementById(
    PC_SEARCH_MODAL_ROOT_ID
  );
  return createPortal(
    <div
      className={twMerge(
        'absolute top-full left-0 rounded-[8px] border-theme-transparent-10 bg-theme-bg-surface',
        className
      )}
      {...props}
    >
      {children}
    </div>,
    pcSearchModalRootElement as HTMLElement
  );
}
